module.exports = __webpack_public_path__ + "assets/images/92858fba2812b8c1f27738293f5b985a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/ansell-logo.svg
// module id = 820
// module chunks = 0